import { useEffect } from "react";
import { Button, Col, Row } from "reactstrap";
import styles from "./ToastNotification.module.css";
import { MisterIcon } from "@rtel/mister-icons";

function Alert(props: AlertProps) {
  let autoCloseLineBackground = "";

  switch (props.type) {
    case "danger":
      autoCloseLineBackground = "bg-danger";
      break;
    case "success":
      autoCloseLineBackground = "bg-success";
      break;
    case "warning":
      autoCloseLineBackground = "bg-warning"
      break;
    default:
      break;
  }

  useEffect(() => {
    if (props.autoClose === true) {
      const timer = setTimeout(() => {
        props.alertVisibility();
      }, props.autoCloseTime * 1000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, []);

  return (
    <>
      <Col xl={3} className={styles.alertContainer}>
        <div className="position-relative">
          <div
            className={`alert alert-light ${[
              styles.alert,
              styles.boxAnimation,
            ]}`}
            role="alert"
          >
            <Row>
              <Col xs={9}>
                <span className="text-dark">{props.message}</span>
              </Col>

              <Col>
                <Button
                  type="button"
                  className={`close `}
                  data-dismiss="alert"
                  role="close-button"
                  aria-label="Close"
                  onClick={props.alertVisibility}
                  color="danger"
                  size="sm"
                >
                  <span className={styles.Button}>
                  <MisterIcon  name="XClose" size={"sm"} />
                  </span>
                </Button>
              </Col>
            </Row>
            {props.autoClose && (
              <div
                className={`${styles.bottomTimer} ${
                  styles["time-" + props.autoCloseTime]
                } ${autoCloseLineBackground}`}
              ></div>
            )}
          </div>
        </div>
      </Col>
    </>
  );
}

export default Alert;

interface AlertProps {
  type: "success" | "danger" | "warning";
  message: string;
  autoClose: boolean;
  autoCloseTime: 3 | 5 | 10 | 15 | 30 | 45 | 60 | 120 | 180 | 240 | 300 | 360;
  alertVisibility: () => void;
}

export interface AlertFlashCall {
  type: "success" | "danger" | "warning";
  message: string;
}

Alert.defaultProps = {
  autoClose: false,
  autoCloseTime: 3,
};
